import { fontFamily } from './fonts';
import { colors, getColorByType } from './colors';
import { animationTransition } from './animations';
import { heights } from './size';
import { breakpoints } from './breakpoints';

export { colors, getColorByType, fontFamily, animationTransition, heights, breakpoints };
